<div class="td-wb-help-container"
     role="dialog"
     aria-modal="true"
     aria-labelledby="td-wb-aria-help-title">
  <div class="td-wb-help__header">
    <span id="td-wb-aria-help-title"
          class="td-wb-help__header-text"
          role="heading"
          aria-level="1"
          translate="tdWb.help.TITLE"></span>
    <button class="td-wb-help__header-close-button"
            tdWbButton
            tdWbButtonType="icon"
            tabindex="0"
            [attr.aria-label]="'tdWb.help.CLOSE' | tdWbTranslate"
            (click)="close()">
      <td-wb-icon iconId="close--small"
                  size="15"
                  class="td-wb-help__header-close-icon"/>
    </button>
  </div>
  <div class="td-wb-skip">
    <!-- TODO:: Add data-td-wb-scroll-to -->
    <a href=""
       (click)="skipToContent(articleId)"
       translate="tdWb.help.SKIP_TO_CONTENT">
    </a>
  </div>
  <div class="td-wb-help-container-inner">
    <div class="td-wb-help__index">
      @for (topic of topics; track trackByTopicId($index, topic)) {
        <a role="button"
           tabindex="0"
           class="td-wb-help__index-item"
           [attr.aria-pressed]="topic.id === currentTopic?.id"
           [class.td-wb-help__index-item--highlighted]="topic.id === currentTopic?.id"
           href=""
           (click)="loadTopic(topic)">
          <span [innerText]="topic.title"></span>
        </a>
      }
      <div class="td-wb-help__index-bottom">
      </div>
    </div>
    <div class="td-wb-help__content"
         tdWbHelpScroller
         (loadMore)="loadMore($event)">
      @if (hasReachedTopicTop()) {
        @if (hasMoreThanOneLink()) {
          <td-wb-help-article-index (articleSelected)="articleSelected($event)"
                                    [articles]="articles"
                                    [topic]="currentTopic"/>
        }
        @if (!hasMoreThanOneLink()) {
          <a class="td-wb-hide td-wb-help-article-index-item-link"
             [attr.href]="'#/page/help/' + articles[0]?.id"
             [innerText]="'#/page/help/' + articles[0]?.id"></a>
        }
      }
      @for (article of articles; track trackByArticleId($index, article); let isFirst = $first; let isLast = $last) {
        <td-wb-help-desktop-article [id]="article.id"
                                    tabindex="0"
                                    [articleId]="article.id"
                                    [articleContent]="article.html"
                                    [hasFocus]="hasFocus(article.id)"
                                    class="td-wb-help-desktop-article"
                                    [tdWbImageLoad]="isFirst"
                                    (imageLoad)="onImageLoaded()"
                                    [class.td-wb-help__bottom-article]="isLast && hasReachedTopicBottom()"
                                    [class.td-wb-help__article]="!isFirst"/>
        @if (!isLast) {
          <div class="td-wb-help__section-divider"></div>
        }
      }
      @if (loading) {
        <td-wb-detailed-loading-indicator />
      }
    </div>
  </div>
</div>
